const checkout = (() => {

  let checkoutForm = document.querySelector('form[name="checkout"]');
  if (checkoutForm) {
      checkoutForm.addEventListener('submit', function() {
          let submitButtons = document.querySelectorAll('form[name="checkout"] .js-checkout-submit');
          submitButtons.forEach(function (submitButton) {
              submitButton.classList.add('disabled');
              submitButton.children[0].innerText = 'Loading';
              submitButton.children[1].innerText = 'Loading';
              submitButton.children[2].classList.remove('ci-arrow-right')
              submitButton.children[2].classList.add('ci-loading')
          });
      })
  }

})();

export default checkout;
